import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
const NOTIFICATION_PREFERENCES_BASE_URL = '/notification/preferences/v2';
const getNotificationPreferencesKey = () => 'NotificationPreferences';
const _fetchNotificationPreferences = () => http.get(`${NOTIFICATION_PREFERENCES_BASE_URL}/preferences`, {
  query: {
    locale: 'en'
  }
});
const getNotificationPreferences = () => getFromEarlyRequest(getNotificationPreferencesKey(), () => _fetchNotificationPreferences());
export default getNotificationPreferences;